import { Box, OutlinedInput, Typography } from '@mui/material';
import React from 'react';

export const DynamicQuestionFreetext = ({
    question,
    truth,
    answer,
    disabled,
    onChange
}) => {
    return <div>
        <div className="fs-20 fw-semi-bold" style={{whiteSpace: 'pre-line'}}>{question.name}</div>
        {truth && <Box>
            <Typography style={{lineHeight: 1}} component="pre" color="error">{truth}</Typography>
            <Box mb={2} />
            <Typography style={{lineHeight: 1}} component="pre" color="inherit">{answer}</Typography>
        </Box>}

        {!truth && <Box display="flex" flexDirection="column">
            <OutlinedInput multiline value={answer} onChange={event => onChange(event.target.value)} disabled={disabled} />
        </Box>}
    </div>;
};
